<template>
  <div v-if="narocilo !== null && typeof narocilo[atribut] !== 'undefined'" :style="dodatenStil">
    <span v-if="atributNaziv.length > 0">
      {{atributNaziv}}:
    </span>
    <span>
      <b>
        {{ narocilo[atribut] }}
      </b>
    </span>
  </div>
</template>
<script>
export default {
  name: 'MojaNarocilaAtribut',
  props: {
    narocilo: Object,
    atributNaziv: '',
    atribut: '',
    dodatenStil: ''
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/T2klub/MojaNarocilaInfo/MojaNarocilaAtribut.vue